import MuiPaper, { PaperProps } from '@mui/material/Paper';

export type { PaperProps };

export const Paper = (props: PaperProps) => <MuiPaper {...props} />;
